import { PropsWithChildren } from 'react';
import Header from './Header';
import { Box, Flex } from '@agrotoken-tech/ui';

interface MainLayoutProps extends PropsWithChildren {}

const MainLayout = ({ children }: MainLayoutProps) => {
  return (
    <Flex direction="column" minHeight="100vh" alignItems="center">
      <Box width="100%">
        <Header />
      </Box>
      <Box
        flex="1"
        width="100%"
        mt={8}
        px={{ base: 4, md: 8, lg: 20, xl: 0 }}
        maxWidth={'1280px'}
      >
        {children}
      </Box>
    </Flex>
  );
};

export default MainLayout;
